var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTooltip = function SvgTooltip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.986 10.864.5 12V6a6 6 0 1 1 2.511 4.882l-.025-.018Z",
    fill: "#102B3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 3.994c.267-.163.577-.244.931-.244a1.7 1.7 0 0 1 .688.131c.2.088.354.209.462.363a.888.888 0 0 1 .169.537c0 .221-.052.41-.156.569-.1.158-.252.342-.457.55-.17.175-.3.325-.387.45a.896.896 0 0 0-.162.413l-.026.175h-.462V6.68c0-.233.042-.429.125-.587.083-.163.204-.338.363-.525.12-.142.21-.265.268-.369a.667.667 0 0 0 .094-.35.399.399 0 0 0-.156-.337c-.1-.084-.24-.125-.419-.125-.292 0-.583.09-.875.268v-.662Zm.4 3.381h.881v.875h-.881v-.875Z",
    fill: "#fff"
  })));
};
export default SvgTooltip;